const RedactedFields = [
  'accessToken',
  'accountNumber',
  'birthDate',
  'birthday',
  'bornAt',
  'deviceName', // Sometimes includes user name
  'e164',
  'email',
  'emailAddress',
  'embossedName',
  'firstName',
  'lastName',
  'name',
  'pass',
  'passcode',
  'password',
  'pin',
  'phone',
  'phoneNumber',
  'pushToken',
  'routingNumber',
  'socialSecurityNumber',
  'ssn',
];

export const redact = (fmt: string): string => {
  return RedactedFields.reduce((acc, field) => {
    const fieldPattern = new RegExp(`(\\"${field}\\"):\s?\\"(.+?)\\"`, 'g');
    return acc.replace(fieldPattern, '$1:"***"');
  }, fmt);
};

export default redact;
